import {
    GEOLOCATION_STATUS,
    GEOLOCATION_POSITION,
    CANDC_STORE_DETAILS,
    CHANGE_OTHER_METHODS,
    CHANGE_OTHER_STORE
} from "../actionTypes/index";

export const setGeoLocationStatus = value => dispatch => {
    dispatch({ type: GEOLOCATION_STATUS, payload: value });
};

export const setGeoLocationPosition = value => dispatch => {
    dispatch({ type: GEOLOCATION_POSITION, payload: value });
};

export const setStoreDetails = value => dispatch => {
    dispatch({ type: CANDC_STORE_DETAILS, payload: value });
}

export const setChangeStore = value => dispatch => {
    dispatch({ type: CHANGE_OTHER_STORE, payload: value });
}

export const setChangeMethods = value => dispatch => {
    dispatch({ type: CHANGE_OTHER_METHODS, payload: value });
}
